<template>
  <nd-pulldown class="wait-page" :refresh="refresh">
    <div class="page refund-progress">
      <navigation sticky>申请进度详情</navigation>
      <div class="progress-content">
        <!-- 顶部图标和说明文字区域 -->
        <div class="progress-header">
          <div class="icon-wrapper">
            <img class="icon-refund" src="./images/icon_03@2x.png" />
          </div>
          <div class="desc-wrapper">
            <p class="desc-text">用户您好，我们已收到天美贷平台转入的退款申请。为确保您的账户信息及资金安全，需要对您进行身份验证。验证通过后，我们将进行退款处理，将在30个工作日完成，请耐心等待。您可通过查看下方信息更新了解进展。</p>
          </div>
          <div class="process-title">处理流程：</div>
        </div>

        <!-- 处理流程状态卡片 -->
        <div class="process-card">
          <div class="process-item">
            <div class="process-status">
              <img class="status-icon" src="./images/icon_current.png" />
              <div class="status-info">
                <div class="status-title highlight">{{ status.title }}</div>
                <div class="status-time">
                  <!-- 失效时间 -->
                  <template v-if="detail.paramObj.cancel==='Y'">{{detail.paramObj.cancelTime}}</template>
                  <template v-else-if="countDownSeconds>0">{{detail.paramObj.applyTime}}</template>
                  <template v-else>{{detail.paramObj.expTime}}</template> 
                </div>
              </div>
            </div>
            <div class="countdown-wrapper" >
              <p class="countdown-text" v-if="detail.paramObj.cancel==='Y'">您本次退款申请身份验证已取消，本次退款申请已自动失效。如有后续退款需求，请联系客服。</p>
              <p class="countdown-text" v-else-if="countDownSeconds>1">
                <span>您本次退款申请身份验证剩余时间: </span>
                <span class="highlight-time" >
                  <van-count-down
                    :time="countDownSeconds"
                    format="DD天HH时mm分ss秒"
                    @finish="countDownFinished"
                /></span>
                <span>，请尽快完成身份验证，超时未完成，本次退款申请将自动失效</span>
              </p>
              
              <p class="countdown-text" v-else>您本次退款申请身份验超时未完成，本次退款申请已自动失效。如有后续退款需求，请联系客服。</p>
            </div>
          </div>

          <div class="process-item">
            <div class="process-status">
              <img class="status-icon" src="./images/icon_done.png" />
              <div class="status-info">
                <div class="status-title">退款申请已沟通确认</div>
                <div class="status-time">{{detail.paramObj.applyTime}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 底部操作区域 -->
      <div class="action-area" v-if="countDownSeconds>0 && detail.paramObj.cancel != 'Y' && !this.$route.query.result">
        <div 
          class="verify-btn" 
          :class="{ 'disabled': !isAgreed }"
          @click="handleAuth"
        >立即身份验证</div>
        <div class="agreement-tip">
          <div class="ui-check-box" @click="isAgreed = !isAgreed" :class="{isAgreed}"></div>
          <div class="tip-text">
            点击「立即身份验证」按钮前请先阅读并同意签署<span class="link-text" @click="routeCommitmentLetterProtocol">《承诺函》</span>
          </div>
        </div>
      </div>

      <Auth ref="auth" :verificationMode="verificationMode"></Auth>
    </div>
  </nd-pulldown>
</template>

<script>
import dayjs from 'dayjs'
import Auth from '../components/auth.vue'
import { mapActions } from 'vuex'
import { getKey } from '@/assets/utils'
// import dayjs from 'dayjs'
export default {
  components: {
    Auth
  },
  data () {
    return {
      countDownSeconds: 0,
      verificationMode: this.$route.query.verificationMode || '',
      isAgreed: false,
      detail: {
        paramObj: {
          cancelTime: '',
          expTime: '',
          applyTime: '',
          cancel: 'N'
        }
      },
      status: {
        title: '身份验证等待确认'
      }
    }
  },
  mounted () {
    this.refresh()
    this.$bus.$emit('ready')
  },
  methods: {
    ...mapActions('message', ['messageDetail']),
    async refresh () {
      const { success, data } = await this.messageDetail({
        recordNo: this.$route.query.recordNo
      })
      if (success && data) {
        this.detail = data
        if (data?.content?.paramObj?.applyTime) {
          this.detail.paramObj = data.content.paramObj
          this.countDownSeconds = dayjs(data.content.paramObj.expTime).diff(dayjs())

          if (this.detail.paramObj?.cancel === 'Y') {
            this.status.title = '身份验证取消'
          } else if (this.countDownSeconds > 0) {
            this.status.title = '身份验证等待确认'
          } else {
            this.status.title = '身份验证超时未通过'
          }
        }
      }
    },
    async handleAuth () {
      // 身份认证前先校验签章授权，未授权则弹窗引导完成，授权通过才继续认证
      try {
        await this.$signAuth({
          type: 'MOBILE',
          mobile: getKey('userInfo', 'mobile')
        })
      } catch (e) {
        // 用户取消或校验未通过，中止认证
        return
      }
      this.$refs.auth.handleVerifi(true)
    },
    countDownFinished () {
      this.countDownSeconds = 0
      this.status.title = '身份验证超时未通过'
    },
    // 立即身份验证
    verifyIdentity () {
      // 验证逻辑
    },
    // 查看承诺函
    viewPromise () {
      // 查看承诺函逻辑
    },
    routeCommitmentLetterProtocol () {
      const origin = process.env.VUE_APP_PROURL
      window.location.href = `${origin}/protocol/postLoan/commitment-letter`
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.page.refund-progress {
  background: linear-gradient(180deg, #BED4FE 0%, #F3F4F8 100%);
  min-height: 100vh;
  padding-bottom: 340px;
  box-sizing: border-box;
  position: relative;
  .ui-check-box {
    width: 32px;
    height: 32px;
    border: 2px solid #4262E9;
    border-radius: 100px;
    display: inline-block;
    margin-right: 8px;
    &.isAgreed {
      background-color: #4262E9;
      background-image: url('./images/icon_tip.png');
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
    }
  }
  .progress-content {
    padding: 0 40px;
    
    // 顶部图标和说明区域
    .progress-header {
      padding: 40px 0 12px;
      
      .icon-wrapper {
        background-color: #81B0FF;
        border-radius: 50%;
        width: 120px;
        height: 120px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
        
        .icon-refund {
          width: 120px;
          height: 109px;
        }
      }
      
      .desc-wrapper {
        background-color: #FFFFFF;
        border-radius: 20px;
        padding: 20px;
        margin-top: 30px;
        
        .desc-text {
          font-size: 26px;
          color: #333;
          line-height: 37px;
        }
      }
      
      .process-title {
        font-size: 30px;
        color: #333;
        font-weight: 500;
        margin-top: 60px;
        line-height: 42px;
        font-family: PingFangSC, PingFang SC;
      }
    }
    
    // 处理流程状态卡片
    .process-card {
      background-color: #FFFFFF;
      border-radius: 20px;
      padding: 40px 20px;
      
      .process-item {
        margin-bottom: 40px;
        
        &:last-child {
          margin-bottom: 0;
        }
        
        .process-status {
          display: flex;
          align-items: flex-start;
          
          .status-icon {
            width: 32px;
            height: 32px;
            margin-right: 10px;
            margin-top: 6px;
          }
          
          .status-info {
            .status-title {
              font-size: 30px;
              color: #333;
              font-weight: 500;
              line-height: 42px;
              font-family: PingFangSC, PingFang SC;
              &.highlight {
                color: #FF4633;
              }
            }
            
            .status-time {
              font-size: 20px;
              color: #999;
              line-height: 28px;
              margin-top: 4px;
            }
          }
        }
        
        .countdown-wrapper {
          background-color: #FFF6ED;
          padding: 12px;
          margin-left: 42px;
          margin-top: 12px;
          
          .countdown-text {
            font-size: 24px;
            color: #995939;
            line-height: 33px;
            .highlight-time {
              .van-count-down{
                color: #FF4633;
                 font-family: DIN-Medium, DIN;
                font-size: 24px;
                display: inline;
              }
            }
          }
        }
      }
    }
    
    
  }
  // 底部操作区域
    .action-area {
      background-color: #FFFFFF;
      padding: 30px;
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;

            
      .verify-btn {
        background-color: #4262E9;
        color: #FFFFFF;
        font-size: 32px;
        text-align: center;
        line-height: 45px;
        padding: 26px 0;
        border-radius: 16px;
        &.disabled {
          opacity: 0.5;
          pointer-events: none;
        }
      }
      
      .agreement-tip {
        display: flex;
        align-items: flex-start;
        margin-top: 20px;
        
        .tip-icon {
          width: 32px;
          height: 32px;
          margin-right: 8px;
        }
        
        .tip-text {
          font-size: 24px;
          color: #999;
          line-height: 33px;
          
          .link-text {
            color: #4262E9;
          }
        }
      }
    }
}
</style>